import { QueryStatus } from 'src/types'
import { OperacionContraparte } from '../types/types'
import { useEffect, useState } from 'react'
import { HttpContraparte } from '../api/httpContraparte'

export const useOperacionContraparte = (idOperacion: number) => {
    const [status, setStatus] = useState<QueryStatus>(QueryStatus.Idle)
    const [operacion, setOperacion] = useState<OperacionContraparte>()

    useEffect(() => {
        setStatus(QueryStatus.Loading)

        HttpContraparte.get(idOperacion)
            .then(data => {
                setOperacion(data)
                setStatus(QueryStatus.Success)
            })
            .catch(() => setStatus(QueryStatus.Error))
    }, [idOperacion])

    return { status, operacion }
}
